import { createRoute } from 'framework/routing';
import { WORKERS_DASHBOARD_PATH } from './constants';

export const useEmployeesDashboardRoute = () => {
  return createRoute({ listRoute: WORKERS_DASHBOARD_PATH });
};
